import React, {Component} from 'react';
import {connect} from 'react-redux';
import { NavLink, withRouter} from 'react-router-dom';
import { setSearchData } from '../../../redux/actions/searchAction';
import SearchInput, {createFilter} from 'react-search-input'
import EmptyMessage from '../EmptyMessage';
import {setMessageRead} from '../../../redux/actions/messagesAction'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { filterByValuesMessages, parseDate } from '../../../Helpers/HelperFunctions.js';
import RaisedButton from 'material-ui/RaisedButton';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import _ from 'lodash'
import {Input} from 'reactstrap';
import moment from 'moment';
import { extendMoment } from 'moment-range';
import 'moment/locale/nl';

import Pagination from '../Pagination';
class MessagesOverview extends Component {
    constructor(props) {
        super(props);
        this.columns = [{
              Header: 'Bericht',
              accessor: 'subject',
               Cell: props => <span style={props.row._original.has_been_read === '0' ?  {'fontWeight' : 'bold'} : {}}>{props.row._original.is_priority === '1' ? '*' : ''}{props.value}<br /><span style={{ 'fontSize' : '12px', 'color' : 'grey'}}>{props.row._original.message}</span></span>
        },{
              Header: 'Datum',
              accessor: 'date_send',
        },
        {
            Header: 'Bewerken',
            accessor: 'name',
            Cell: props => <span><NavLink to={'/berichten/bekijk/'+props.row._index} style={{display : 'inline'}} className="nav-link">Bericht bekijken</NavLink></span>
        }]

        this.state = {
            visibleMessages : [],
            selectedMessages : [],
            allMessages: [],
            date_till : false,
            date_from : false,
            date_till_executed : false,
            date_from_executed : false,
            filtersVisible: false,
            filterValues: {},
            filteredMessages: false,
            fileTypeMetaCategories: false,
            address: false,
            filters : {
                is_priority : false,
                is_no_priority : false,
                has_been_read : false
            }
        }

        this._mapMetaCategories = this._mapMetaCategories.bind(this);
        this._getSelectedValue = this._getSelectedValue.bind(this);
        this._mapMetaTextValues = this._mapMetaTextValues.bind(this);
        this._handleDateChange = this._handleDateChange.bind(this);
        this._setTextValue = this._setTextValue.bind(this);

        this._getMessages = this._getMessages.bind(this);
        this.moment = extendMoment(moment);
        this.moment.locale('nl')
        this.filterValues = {
            isPriority : {
                name: 'Is urgent',
                type: 'checkbox',
                key: 'is_priority',
                keyName:'is_priority',
                value : '1'
            },
             isNoPriority : {
                name: 'Is niet urgent',
                type: 'checkbox',
                key: 'is_priority',
                keyName:'is_no_priority',
                value : '0'
            },
            hasBeenRead : {
                name: 'Is ongelezen',
                type: 'checkbox',
                key: 'has_been_read',
                value : '0'
            }
        }
    }

    componentDidMount() {

        if(this.props.match.params.addressId) {
            const address = this.props.addresses.find( address => address.dp_address_id === this.props.match.params.addressId );
            this.setState({address: address});
        }

        let searchTerm = false;
        let filters = {...this.state.filters};
        let fileType = this.state.fileType;
        let fileTypeMetaCategories = this.state.fileTypeMetaCategories;
        let filterValues = {...this.state.filterValues}
        let date_till = this.state.date_till;
        let date_from = this.state.date_from;
        let date_from_executed = this.state.date_from_executed;
        let date_till_executed = this.state.date_till_executed;

        const searchScope = 'messages'

        if ( searchScope ) {
			let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
			if ( jsonData ) {

				if ( jsonData[searchScope] ) {

                    if ( jsonData[searchScope].searchTerm ) {
                        searchTerm = jsonData[searchScope].searchTerm
                    }

                    if ( jsonData[searchScope].filters ) {
                        filters = jsonData[searchScope].filters
                    }

                    if ( jsonData[searchScope].fileType ) {
                        fileType = jsonData[searchScope].fileType
                    }
                    if ( jsonData[searchScope].fileTypeMetaCategories ) {
                        fileTypeMetaCategories = jsonData[searchScope].fileTypeMetaCategories
                    }
                    if ( jsonData[searchScope].filterValues ) {
                        filterValues = jsonData[searchScope].filterValues
                    }

                    if ( jsonData[searchScope].date_from ) {
                        date_from = this.moment(jsonData[searchScope].date_from);
                    }

                    if ( jsonData[searchScope].date_from_executed ) {
                        date_from_executed = this.moment(jsonData[searchScope].date_from_executed);
                    }

                    if ( jsonData[searchScope].date_till ) {
                        date_till = this.moment(jsonData[searchScope].date_till);
                    }

                    if ( jsonData[searchScope].date_till_executed ) {
                        date_till_executed = this.moment(jsonData[searchScope].date_till_executed)
                    }
				}
			}
		}

        if ( this.props.match.params.searchInput ) {
            this._setSearchTerm(this.props.match.params.searchInput)
            searchTerm = this.props.match.params.searchInput;
        }

        this.setState({
            ...this.state,
            searchTerm : searchTerm,
            filters : filters,
            allMessages : this._getMessages(true),
            fileType : fileType,
            fileTypeMetaCategories : fileTypeMetaCategories,
            filterValues : filterValues,
            date_from : date_from,
            date_from_executed : date_from_executed,
            date_till_executed : date_till_executed,
            date_till : date_till
        })

        document.querySelector('title').innerHTML = 'MijnDP - Berichten';


        // -- If an address exists, add it to scoped searchdata. This way we'll know if the previous page was based on an address, we'll have to reset all filters if that's the case.
        if(this.props.match.params.addressId) {
            let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
            if ( searchScope ) {
                jsonData = {
                    ...jsonData,
                    [searchScope] : {
                        ...jsonData[searchScope],
                        address_id : this.props.match.params.addressId
                    }
                }
            }
            localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
        } else {
            let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
            if ( searchScope ) {
                if ( jsonData ) {
                    if ( jsonData[searchScope]) {
                        if ( jsonData[searchScope].address_id ) {
                            jsonData = {
                                ...jsonData,
                                [searchScope] : {
                                    ...jsonData[searchScope],
                                    address_id : false
                                }
                            }
                            localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
                            this._resetAll();
                        }
                    }
                }


            }
        }
    }

    componentDidUpdate(prevProps) {

        if ( JSON.stringify(this._getMessages(true)) !== JSON.stringify(this.state.allMessages)) {
            this.setState({
                ...this.state,
                allMessages : this._getMessages(true)
            })
        }
    }

    _applyFilters = () => {

    }

    _mapMetaCategories = (categoryId, key) => {
        const categoryObject = this.state.fileTypeMetaCategories[categoryId];
        if(categoryObject) {
            return (
                    <div className="filter__column" key={key}>
                        <div><h2>{categoryObject.category}</h2></div>
                            {categoryObject.is_text === 1 ? categoryObject.values.map((value, key) => this._mapMetaTextValues(value, categoryId, categoryObject))
                            :
                                categoryObject.values ?
                                    <Select
                                        placeholder="Selecteer een waarde"
                                        simpleValue={true}
                                        onChange={value => this._setSelectedValue(value, categoryId, categoryObject)}
                                        value={this._getSelectedValue(categoryObject.category)}
                                        options={categoryObject.values ? categoryObject.values.map((value, key) => this.mapMetaSelectValues(value, categoryId)) : null}
                                        multi={categoryObject.is_unique === "1" ? false : true}
                                    />
                                : null

                            }
                    </div>


            )
        }
    }

     _getSelectedValue = (category) => {

        if(this.state.filterValues[category]) {
            return this.state.filterValues[category]
        }
    }


    _setSelectedValue = (value, categoryId, categoryObject) => {
        let filterValues = this.state.filterValues;

        if(!value) {
            delete filterValues[categoryObject.category];
        }else{
            filterValues[categoryObject.category] = value;
        }

        this.setState({
            ...this.state,
            filterValues
        })

        const searchScope = localStorage.getItem('searchScope');
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
        if ( searchScope ) {
            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    filterValues : filterValues
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
    }

    _setActiveCheckbox = (messageId, id = false) => {
        const currentSelectedMessages = [...this.state.selectedMessages];
        let newSelectedMessages = [];

        if ( currentSelectedMessages.includes(messageId) ) {
            currentSelectedMessages.forEach((item, i) => {
                if ( item !== messageId ) {
                    newSelectedMessages.push(item);
                }
            })
        } else {
            newSelectedMessages = currentSelectedMessages;
            newSelectedMessages.push(messageId);
        }

        this.setState({
            ...this.state,
            selectedMessages : newSelectedMessages
        });
    }

    _getButtonMessage = () => {
        const currentSelectedMessages = [...this.state.selectedMessages];
        const currentVisibleMessages = [...this.state.visibleMessages];

        if ( JSON.stringify(currentSelectedMessages) === JSON.stringify(currentVisibleMessages)) {
            return 'Sluit de details van geselecteerde berichten';
        } else {
            return 'Toon de details van geselecteerde berichten';
        }
    }
    _toggleSelectedMessages = () => {
        const currentSelectedMessages = [...this.state.selectedMessages];
        const currentVisibleMessages = [...this.state.visibleMessages];

        let newVisibleMessages = [];

        currentSelectedMessages.forEach((item, i) => {
            newVisibleMessages.push(item);
        });

        

        if ( this.state.visibleMessages.length && !newVisibleMessages.length ) {
            for (let index = 0; index < this.state.visibleMessages.length; index++) {
                this._setMessageRead(this.state.visibleMessages[index]);
            }
        }

        if ( JSON.stringify(newVisibleMessages) === JSON.stringify(currentVisibleMessages)) {

            for (let index = 0; index < currentVisibleMessages.length; index++) {
                this._setMessageRead(currentVisibleMessages[index]);
            }

            this.setState({
                ...this.state,
                visibleMessages : []
            });
        } else {
            this.setState({
                ...this.state,
                visibleMessages : newVisibleMessages
            });
        }


    }

    _setMessageRead = (messageId) => {
        if(this.props.user.user_profile.is_representative != '1') {

            let messageReadData = this.state.allMessages
            let messageIndex = _.findIndex(messageReadData, function(a){ return a.message_id === messageId});

            if(messageIndex >= 0) {

                //messageReadData[messageIndex].has_been_read = "1";
                messageReadData[messageIndex].has_been_read_clientside = "1";
               // this.props.updateSearchData(messageReadData)

            }

            this.props.setMessageRead(this.props.clientPath, messageId, this.props.user.user_id, true);
        }
    }

    _showDetails = (event, messageId, id) => {
        event.preventDefault();




        const currentVisibleMessages = [...this.state.visibleMessages];
        let newVisibibleMessages = [];
        if ( currentVisibleMessages.includes(messageId) ) {
            this._setMessageRead(messageId);
            currentVisibleMessages.forEach((item, i) => {
                if ( item !== messageId ) {
                    newVisibibleMessages.push(item);
                }
            });
        } else {
            newVisibibleMessages = currentVisibleMessages;
            newVisibibleMessages.push(messageId);
        }

        this.setState({
            ...this.state,
            visibleMessages : newVisibibleMessages
        });

    }

    _setSelectedFileType = (value) => {

        let fileTypeMetaCategories = this.props.file_types[value];

        this.setState({
            ...this.state,
            fileType: value,
            fileTypeMetaCategories : fileTypeMetaCategories,
            filterValues: {

            }
        });

        const searchScope = localStorage.getItem('searchScope');
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
        if ( searchScope ) {
            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    fileType: value,
                    fileTypeMetaCategories : fileTypeMetaCategories,
                    filterValues: {

                    }
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
    }

     _renderFilterFileTypes = () => {
        return(
            <Select
                simpleValue={true}
                placeholder="Uitgebreid filteren"
                onChange={this._setSelectedFileType}
                value={this.state.fileType}
                multi={false}
                options={this.props.messages.filters ? this._mapFileTypes() : null}
            />
        )
    }

    _mapFileTypes = () => {
        let options = [];
        let fileTypes = this.props.file_types;
        Object.keys(fileTypes).map(function(index){
            if(fileTypes[index]) {
                let option = {value: index, label: fileTypes[index]['file_type_name']};
                options.push(option);

            }
            return true;
        })

        return options;
    }

    mapMetaSelectValues = (valueObject, key) => {
          return ({value: valueObject.name, label: valueObject.name})
    }

    _getTextValue = (valueId, valueObject) => {

        if(!this.state.filterValues)
                return null;

        if(this.state.filterValues[valueId+'_text']) {
            return this.state.filterValues[valueId+'_text']
        } else {
            return null;
        }
    }

    _handleDateChange = (date, key) => {

        let filterValues = this.state.filterValues;

        if(!date) {
            delete filterValues['date_'+key];
        }else{
            filterValues['date_'+key] = date;
        }
        this.setState({
             ...this.state,
             filterValues
         })
      }

     _setTextValue = (category, e) => {

         let value = false;
         if ( e ) {
             value = e.target.value;
         }
        let filterValues = this.state.filterValues;

        if(!value) {
            delete filterValues[category]
        }else{
            filterValues[category] = value;
        }
       this.setState({
            ...this.state,
            filterValues
        })
    }

    _mapMetaTextValues = (valueObject, key, categoryObject) => {
        return (

                <label onClick={e => e.preventDefault()} key={key}>
                    {valueObject.is_date === '1' ?
                         <DatePicker
                            autoComplete="off"
                            dateFormat="DD-MM-YYYY"
                            shouldCloseOnSelect={true}
                            locale='nl-nl'
                            placeholderText="Vul een datum in"
                            selected={
                                   this.state.filterValues['date_'+key] ? this.state.filterValues['date_'+key] : null
                                    }
                            data-categoryid={key}
                            onChange={(date) => this._handleDateChange(date, key)}
                            onBlur={(event) => this._setTextValue(categoryObject.category, event)}  />
                        :
                        <input autoComplete="off" type="text" placeholder="Vul een waarde in" data-categoryid={key} onChange={(event) => this._setTextValue(categoryObject.category, event)} name={key} />
                    }
                   &nbsp;{valueObject.name}
                </label>

        )
    }



    _renderFilterView = () => {
        return (
            <div>
            {this._renderFilterFileTypes()}

            <div className="columnized__filters">
                {this.state.fileTypeMetaCategories ? Object.keys(this.state.fileTypeMetaCategories).map((category, key) => this._mapMetaCategories(category, key)) : null}
            </div>
            <div className="columnized__filters">



            </div>
            </div>
        )
    }

    _getMessageCount = (messages, isPriority, hasBeenRead) => {
        let unreadCount = 0;
        let messageIds = [];
        if(messages) {
            messages.forEach((item, i) => {
                if(this.props.match.params.addressId) {
                    if(Number(item.has_been_read) === hasBeenRead && Number(item.is_priority) === isPriority && item.dp_address_id === this.props.match.params.addressId) {
                        if(!messageIds.includes(item.message_id)) {
                            messageIds.push(item.message_id);
                            unreadCount++;
                        }

                    }
                } else {
                    if(Number(item.has_been_read) === hasBeenRead && Number(item.is_priority) === isPriority) {
                        if(!messageIds.includes(item.message_id)) {
                            messageIds.push(item.message_id);
                            unreadCount++;
                        }

                    }
                }

            });
        }

        return unreadCount;
    }

     _getMessages = (ignoreSearchData = false) => {

        let messages = false;
        let messageData = []
        if(this.props.messages.data) {
            messageData = this.props.messages.data;
            if (messageData.data ) {
                messageData = messageData.data;
            }
        }

        if(this.props.match.params.addressId) {
            messages = messageData.filter( message => message.dp_address_id === this.props.match.params.addressId);
        }else{
            messages = messageData;
        }

        messages = this._sortMessages(messages);

        return messages
    }

    _sortByDate = (values) => {

        values.sort(function(a, b) {
          var keyA = new Date(a.date_send),
            keyB = new Date(b.date_send);
          // Compare the 2 dates
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
          return 0;
        });

        return values;
    }

    _sortMessages = messages => {
        let returnValues = [];

        let sortableValues = [];
        let sortedValues = [];

        // -- For each sort type, we'll add items to an emptied 'sortableValues' array and sort that array by date.
        // -- After that, we'll push the items into the returnvalues one by one.
        if(messages) {
            if ( messages.data ) {
                messages = messages.data;
            }
            // -- First sort
            let addValues = messages.filter( message => message != null ? message.is_priority === '1' && message.has_been_read === '0' : []);
            for(let i = 0; i <= addValues.length; i++) {
                if(addValues[i]) {
                    sortableValues.push(addValues[i]);
                }
            }
            sortedValues = this._sortByDate(sortableValues);
            sortedValues.forEach((item, i) => {
                returnValues.push(item);
            });

            // -- Second sort
            // -- Clear sortable values & sortedvalues
            sortableValues = [];
            sortedValues = [];
            addValues = messages.filter( message => message != null ? message.is_priority === '0' && message.has_been_read === '0' : []);
            returnValues.concat(addValues);
            for(let i = 0; i <= addValues.length; i++) {
                if(addValues[i]) {
                    sortableValues.push(addValues[i]);
                }
            }

            sortedValues = this._sortByDate(sortableValues);
            sortedValues.forEach((item, i) => {
                returnValues.push(item);
            });


            // -- Third sort
            // -- Clear sortable values & sortedvalues
            sortableValues = [];
            sortedValues = [];
            addValues = messages.filter( message => message != null ? message.has_been_read === '1' : []);
            returnValues.concat(addValues);
            for(let i = 0; i <= addValues.length; i++) {
                if(addValues[i]) {
                    sortableValues.push(addValues[i]);
                }
            }

            sortedValues = this._sortByDate(sortableValues);
            sortedValues.forEach((item, i) => {
                returnValues.push(item);
            });
        }

        return returnValues;

    }

    toggleUnreadUrgent = (e) => {
        e.preventDefault();
        this.setState({
            ...this.state,
            filters : {
                is_priority : true,
                is_no_priority : false,
                has_been_read : true

            }
        })
    }

    toggleUnreadNonUrgent = (e) => {
        e.preventDefault();
        this.setState({
            ...this.state,
            filters : {
                is_priority : false,
                is_no_priority : true,
                has_been_read : true

            }
        })
    }

    _checkFilterActive = (filter) => {

        if ( filter === 'isPriority' && this.state.filters.is_priority ) {
            return true;
        }

        if ( filter === 'hasBeenRead' && this.state.filters.has_been_read ) {
            return true;
        }

        if ( filter === 'isNoPriority' && this.state.filters.is_no_priority) {
            return true;
        }

        return false;
    }

    mapFilters = (filter, key) => {
        const values = this.filterValues;
        switch(values[filter]['type']) {
            case 'checkbox':
                return (
                    <div className="checkbox__container" key={key}>
                      <label>
                        <Input
                            className="input__checkbox--search"
                            onChange={(e) => this.searchUpdated(values[filter], values[filter]['key']+'_'+values[filter]['value'])}
                            type="checkbox"
                            name={values[filter]['keyName'] ? values[filter]['keyName'] : values[filter]['key']}
                            lookfor={values[filter]['value']}
                            checked={this._checkFilterActive(filter)}
                        />
                        &nbsp;{values[filter]['name']}

                      </label>
                    </div>
                )
            default:
                return('')
        }
    }

    searchUpdated = (par1, par2) => {

        let value = false;

        if ( par1.key === 'is_priority' && par1.value === '1') {
            value = 'is_priority';
        } else if (par1.key === 'is_priority' && par1.value === '0') {
            value = 'is_no_priority';
        }

        if ( par1.key === 'has_been_read') {
            value = 'has_been_read';
        }
        const filters = {
            ...this.state.filters,
            [value] : !this.state.filters[value]
        }

        this.setState({
            ...this.state,
            filters : filters
        })

        const searchScope = localStorage.getItem('searchScope');
		let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
		if ( searchScope ) {
            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    filters : filters,
                    searchTerm : this.state.searchTerm
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
    }

    _getFilteredData = (data = []) => {

        data = filterByValuesMessages(data, this.state.filterValues, this.state.fileType);

        if ( this.state.searchTerm ) {
            data = data.filter(createFilter(this.state.searchTerm, ['subject','message','metaDataValues']))
        }

        let dateFilteredData = [];

        if(this.state.date_from && this.state.date_till) {
            const currentState = {...this.state};

            const range = this.moment.range(currentState.date_from.format('YYYY-MM-DD'), currentState.date_till.add(1, 'day').format('YYYY-MM-DD'));

            data.forEach((item, i) => {
              let curDate = this.moment(item.date_send);
              if(range.contains(curDate)) {
                   dateFilteredData.push(item);
               }
            });

            data = dateFilteredData;

            currentState.date_till.subtract(1, 'day');
        }

        let dateExecutedFilteredData = [];
        if(this.state.date_from_executed && this.state.date_till_executed) {
            const currentState = {...this.state};

            const dateFrom = {...this.state.date_from_executed}
            const dateTo = {...this.state.date_till_executed};
            moment(dateFrom).format('YYYY-MM-DD');
            const executedRange = this.moment.range(moment(dateFrom).format('YYYY-MM-DD'), moment(dateTo).add(1, 'day').format('YYYY-MM-DD'));

            data.forEach((item, i) => {
               let executedDate = false;
               if ( item.metaDataAsList ) {
                   item.metaDataAsList.forEach((metaDataItem, i) => {
                       if ( metaDataItem.Uitvoerdatum ) {
                           executedDate = moment(metaDataItem.Uitvoerdatum, 'DD-MM-YYYY');
                       }
                   });
               }


               if ( executedDate ) {
                   if(executedRange.contains(executedDate)) {
                       dateExecutedFilteredData.push(item);
                   }
               }
            });

            data = dateExecutedFilteredData;

        }

        let newData = [];
        if ( this.state.filters.is_priority || this.state.filters.is_no_priority || this.state.filters.has_been_read ) {
            // -- We need some filtering

            if ( this.state.filters.is_priority && !this.state.filters.is_no_priority && !this.state.filters.has_been_read ) {
                // -- Only priority items

                data.forEach((item, i) => {
                    if ( item.is_priority === '1') {
                        newData.push(item);
                    }
                });
            }

            if ( !this.state.filters.is_priority && this.state.filters.is_no_priority && !this.state.filters.has_been_read ) {
                // -- Only non-priority items
                data.forEach((item, i) => {
                    if ( item.is_priority !== '1') {
                        newData.push(item);
                    }
                });
            }

            if ( !this.state.filters.is_priority && !this.state.filters.is_no_priority && this.state.filters.has_been_read ) {
                // -- Only unread items
                data.forEach((item, i) => {
                    if ( item.has_been_read === '0') {
                        newData.push(item);
                    }
                });
            }

            if ( this.state.filters.is_priority && !this.state.filters.is_no_priority && this.state.filters.has_been_read ) {
                // -- Only unread items
                data.forEach((item, i) => {
                    if ( item.has_been_read === '0' && item.is_priority === '1') {
                        newData.push(item);
                    }
                });
            }

            if ( !this.state.filters.is_priority && this.state.filters.is_no_priority && this.state.filters.has_been_read ) {
                // -- Only unread items
                data.forEach((item, i) => {
                    if ( item.has_been_read === '0' && item.is_priority === '0') {
                        newData.push(item);
                    }
                });
            }

            if ( this.state.filters.is_priority && this.state.filters.is_no_priority && this.state.filters.has_been_read ) {
                // -- Only unread items
                data.forEach((item, i) => {
                    if ( (item.has_been_read === '0' && item.is_priority === '0') ||  (item.has_been_read === '0' && item.is_priority === '1')) {
                        newData.push(item);
                    }
                });
            }

            if ( this.state.filters.is_priority && this.state.filters.is_no_priority && !this.state.filters.has_been_read ) {
                // -- Only unread items
                data.forEach((item, i) => {
                    if ( item.is_priority === '0' || item.is_priority === '1') {
                        newData.push(item);
                    }
                });
            }
        } else {

            let newDataNoDoubles = [];
            data.forEach((item, i) => {
                if (!newDataNoDoubles.find( subItem => subItem.message_id === item.message_id)) {
                    newDataNoDoubles.push(item);
                }
            });

            return newDataNoDoubles;
        }

        let newDataNoDoubles = [];

        newData.forEach((item, i) => {
            if (!newDataNoDoubles.find( subItem => subItem.message_id === item.message_id)) {
                newDataNoDoubles.push(item);
            }
        });

        return newDataNoDoubles;
    }

    _renderCurrentAddress = () => {

        const address = this.props.addresses.find( address => (address != null ? address.dp_address_id === this.props.match.params.addressId : false));

        if ( address ) {
            return (
                <div className="card">
                    <div className="card__header">
                        <h1>U bekijkt alle berichten van onderstaand adres:</h1>
                        <NavLink className="top__right__link top__right__link--close" onClick={this._resetAll} to="/berichten">Adresfilter sluiten <i class="fa fa-times"></i></NavLink>
                    </div>
                    <div className="card__body">
                        <div className="messages-overview__address">
                            <p>{address.street}</p>
                            <p>{address.zipcode} {address.city}</p>
                        </div>
                    </div>
                    <div className="card__footer card__footer--2-col">
                        <div className="card__footer__back-link">
                            <NavLink to={"/adressen/bekijken/"+this.props.match.params.addressId} className="bottom__left__link">Kies een ander adres</NavLink>
                        </div>
                        <div className="card__footer__save-link">

                        </div>
                    </div>
                </div>
            )
        }
    }

    _setSearchTerm = (term) => {

        this.setState({
            ...this.state,
            searchTerm : term
        }, this._searchUpdated)


        const searchScope = localStorage.getItem('searchScope');
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));

		if ( searchScope ) {

            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    searchTerm : this.state.searchTerm
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
    }

    _changeFromDate = (date) => {
	    this.setState({
	      ...this.state,
	      date_from: date
	  }, this._searchUpdated);

      const searchScope = localStorage.getItem('searchScope');
      let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
      if ( searchScope ) {
          jsonData = {
              ...jsonData,
              [searchScope] : {
                  ...jsonData[searchScope],
                  date_from : date
              }
          }
      }
      localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
	}

    _changeExecutedFromDate = (date) => {
	    this.setState({
	      ...this.state,
	      date_from_executed: date
	  }, this._searchUpdated);

      const searchScope = localStorage.getItem('searchScope');
      let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
      if ( searchScope ) {
          jsonData = {
              ...jsonData,
              [searchScope] : {
                  ...jsonData[searchScope],
                  date_from_executed : date
              }
          }
      }
      localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
	}

	_changeTillDate = (date) => {
	    this.setState({
	      ...this.state,
	      date_till: date
	    }, this._searchUpdated);

        const searchScope = localStorage.getItem('searchScope');
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
        if ( searchScope ) {
            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    date_till : date
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
	}

    _changeExecutedTillDate = (date) => {
	    this.setState({
	      ...this.state,
	      date_till_executed: date
	    }, this._searchUpdated);

        const searchScope = localStorage.getItem('searchScope');
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
        if ( searchScope ) {
            jsonData = {
                ...jsonData,
                [searchScope] : {
                    ...jsonData[searchScope],
                    date_till_executed : date
                }
            }
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
	}

    _resetAll = () => {
        this.setState({
            filtersVisible: false,
            filterValues: {},
            fileType: false,
            fileTypeMetaCategories : false,
            filteredMessages: false,
            date_from : false,
            date_till : false,
            date_from_executed : false,
            date_till_executed: false,

            filters : {
                is_priority : false,
                is_no_priority : false,
                has_been_read : false
            },
        });

        const searchScope = localStorage.getItem('searchScope');

        if ( searchScope ) {
            let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
            if ( jsonData ) {
                jsonData = {
                    ...jsonData,
                    [searchScope] : {
                        ...jsonData[searchScope],
                        searchTerm : '',
                        filters : {
                            is_priority : false,
                            is_no_priority : false,
                            has_been_read : false
                        },
                        fileType : false,
                        fileTypeMetaCategories : false,
                        filterValues : {},
                        date_from : false,
                        date_till : false
                    }


                }

            }
            localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
        }
    }

    _selectAllCheckboxes = () => {
        const checkboxes = document.querySelectorAll('.message__checkbox__inner input');
        let ids = [];
        checkboxes.forEach((item, i) => {
            const id = item.getAttribute('data-attr');
            ids.push(id);
        })

        if ( JSON.stringify(this.state.selectedMessages) === JSON.stringify(ids)) {
            this.setState({
                selectedMessages : []
            }, this._toggleSelectedMessages)
        } else {
            this.setState({
                selectedMessages : ids
            }, this._toggleSelectedMessages)
        }


    }

    _resetActiveItems = () => {
        this.setState({
            selectedMessages : []
        }, this._toggleSelectedMessages)
    }

    render() {
        return (
            <div>

                <div className="card">
                    <ul className="top__list top__list--messages top__list--unmarged">
                        <li style={{cursor: 'pointer'}}>
                            <a onClick={this.toggleUnreadUrgent}>
                                <div className="item__title">Ongelezen urgente berichten</div>
                                <div style={{color: '#e30613'}} className="item__value">{this._getMessageCount(_.compact(this.state.allMessages), 1, 0)}</div>
                            </a>
                        </li>
                        <li style={{cursor: 'pointer'}}>
                            <a onClick={this.toggleUnreadNonUrgent}>
                                <div className="item__title">Ongelezen niet urgente berichten</div>
                                <div style={{color: '#3aaa35'}}  className="item__value">{this._getMessageCount(_.compact(this.state.allMessages), 0, 0)}</div>
                            </a>
                        </li>
                        <li>
                            <NavLink to="/adressen">
                                <div className="item__title">Totaal adressen</div>
                                <div  className="item__value">{_.compact(this.props.addresses).length}</div>
                            </NavLink>
                        </li>
                    </ul>
                </div>
                {this.props.match.params.addressId ? this._renderCurrentAddress() : null }

                <div className="card">
                    <div className="card__body">

                        <div className="card__content">
                            <div className="search__wrapper">
                                <span style={{cursor : 'pointer'}} onClick={this._resetAll} className="top__right__link">Reset filters</span>
                                <div>
                                    <div className="search__wrapper__input-wrapper">
                                        <button onClick={() => this._setSearchTerm('')} className="search-reset"><i className="fa fa-times"></i></button>
                                        <SearchInput placeholder="Zoeken door alle berichten: adres, plaats, postcode 1234AB, casenummer, contractnummer, type document, uitslag, etc." value={this.state.searchTerm ? this.state.searchTerm : ''} className="filter__input search__wrapper__input-wrapper__inner" inputClassName="form-control input__text--search  input--unstyled" onChange={this._setSearchTerm} />
                                    </div>
                                    <div className="filter__input">
                                        {Object.keys(this.filterValues).map((filter, key) => this.mapFilters(filter, key))}
                                    </div>
                                </div>

                                <span>
              						<div className="datepickers__wrapper">
              							<div className="datepicker__single">
              								<DatePicker placeholderText="Verzenddatum bericht van" dateFormat="DD-MM-YYYY" selected={this.state.date_from ? this.state.date_from : null}  onChange={date => this._changeFromDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
            							</div>
            		  					<div className="datepicker__single">
            		  						<DatePicker placeholderText="Verzenddatum bericht tot" dateFormat="DD-MM-YYYY" selected={this.state.date_till ? this.state.date_till : null}  onChange={date => this._changeTillDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
            		  					</div>
                                        <div className="datepicker__single">
              								<DatePicker placeholderText="Uitvoerdatum bericht van" dateFormat="DD-MM-YYYY" selected={this.state.date_from_executed ? this.state.date_from_executed : null}  onChange={date => this._changeExecutedFromDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
            							</div>
            		  					<div className="datepicker__single">
            		  						<DatePicker placeholderText="Uitvoerdatum bericht tot" dateFormat="DD-MM-YYYY" selected={this.state.date_till_executed ? this.state.date_till_executed : null}  onChange={date => this._changeExecutedTillDate(date)} shouldCloseOnSelect={true} locale='nl-nl'  />
            		  					</div>
            		  				</div>
            	  				</span>
                                <div className="extended__filters">
                                    {this._renderFilterView()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card" >
                    <div className="card__body">
                        <div className="card__content">
                        {this._getFilteredData(this.state.allMessages) ?
                            this._getFilteredData(this.state.allMessages).length ?
                                <span className="top__right__link top__right__link--close"
                                    onClick={this._selectAllCheckboxes}
                                    style={{marginTop : 0, marginBottom: 25, cursor: 'pointer'}}
                                >
                                Allemaal open / dicht
                                </span>
                            : null
                        : null }


                            <div className="messages__list__headers">
                                <div className="subject"><span className="inner">Onderwerp</span></div>
                                <div className="date"><span className="inner">Verzenddatum</span></div>
                                <div className="date_executed"><span className="inner">Uitvoerdatum</span></div>
                            </div>

                            <ul className="messages-list">
                                {this._getFilteredData(this.state.allMessages) ?
                                    this._getFilteredData(this.state.allMessages).length ?
                                        <Pagination
                                            setSearchTerm={this._setSearchTerm}
                                            resetActiveItems={this._resetActiveItems}
                                            data={this._getFilteredData(this.state.allMessages)}
                                            visibleMessages={this.state.visibleMessages}
                                            selectedMessages={this.state.selectedMessages}
                                            showDetails={this._showDetails}
                                            isFromOverview={true}
                                            setActiveCheckbox={this._setActiveCheckbox}
                                        />
                                        :
                                    <EmptyMessage /> :
                                <EmptyMessage />}

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps (state) {
    return {
        messages: state.messagesReducer.messages,
        file_types: state.messagesReducer.file_types,
        searchData: state.SearchDataReducer,
        addresses: state.AddressReducer.addresses,
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        setMessageRead: (url, messageId, userId, setReadNow) => dispatch(setMessageRead(url,messageId, userId, setReadNow)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, false, {pure : false})(MessagesOverview));



// WEBPACK FOOTER //
// ./src/components/Messages/Overview/index.js